import { render, staticRenderFns } from "./TransferInformation.vue?vue&type=template&id=85cc6faa&scoped=true"
import script from "./TransferInformation.vue?vue&type=script&lang=js"
export * from "./TransferInformation.vue?vue&type=script&lang=js"
import style0 from "./TransferInformation.vue?vue&type=style&index=0&id=85cc6faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc6faa",
  null
  
)

export default component.exports